// src/components/BlackCaiman.jsx
import React from 'react';
import '../../../css/float.css'; // provides the "bob" animation
import '../../../css/glow.css';  // optional glow-light / glow-dark

/**
 * Black Caiman that gently bobs in place (no horizontal float).
 */
export default function SwimmingBlackCaiman({
  width = 150,
  top = '68%',          // position it in the Runs zone
  left = '35%',
  theme = 'light',
  highlight = false,
  bobDuration = '4s',   // how floaty the bob feels
  onClick,
  zIndex = 20,
}) {
  const url = '/images/animals/5_20m/predator/black_caiman_head.png';

  const classes = [
    'bob', // vertical bob from float.css
    theme === 'light' ? 'glow-light' : 'glow-dark',
    highlight ? 'ring-4 ring-yellow-300 rounded-full' : '',
  ].filter(Boolean).join(' ');

  const handleKeyDown = (e) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); }
  };

  return (
    <div
      style={{
        position: 'absolute',
        top,
        left,
        transform: 'translate(-50%, -50%)',
        zIndex,
        pointerEvents: 'auto',
      }}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label="Black Caiman"
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <img
        src={url}
        alt="Black Caiman"
        className={classes}
        draggable={false}
        style={{
          width: `${width}px`,
          display: 'block',
          cursor: onClick ? 'pointer' : 'default',
          animationDuration: bobDuration, // override bob speed if desired
        }}
        onError={(e) =>
          console.warn('[BlackCaiman] image failed to load:', e.currentTarget.src)
        }
      />
    </div>
  );
}
